import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=4124970f"
var script = {}
import style0 from "./Notifications.vue?vue&type=style&index=0&id=4124970f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports